import { render, staticRenderFns } from "./BannerSectorComponent.vue?vue&type=template&id=138a002d&scoped=true"
import script from "./BannerSectorComponent.vue?vue&type=script&lang=js"
export * from "./BannerSectorComponent.vue?vue&type=script&lang=js"
import style0 from "./BannerSectorComponent.vue?vue&type=style&index=0&id=138a002d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138a002d",
  null
  
)

export default component.exports